// src/components/guards/useAvisoEmpresa.js
//
// EL AVISO DE PRIVACIDAD DEL EMPLEADO DE EMPRESA (EMPRESAS.md, T2.5) — los datos.
// La pantalla vive en `AvisoEmpresa.jsx`; aquí, lo que habla con el backend.
//
// La regla de a quién se le pide vive en el backend (`src/empresas/aviso.py`):
// aquí solo se lee `pendiente`. Si la pregunta falla —red, 5xx, 429— se deja
// pasar: un aviso que no carga no puede dejar a toda la app sin entrar.

import { useCallback, useEffect, useState } from 'react';

const SIN_AVISO = { cargando: false, pendiente: false, datos: null };

function token() {
  try { return localStorage.getItem('token'); } catch { return null; }
}

export function useAvisoEmpresa() {
  const [estado, setEstado] = useState(() => (token() ? { ...SIN_AVISO, cargando: true } : SIN_AVISO));

  const carga = useCallback(async () => {
    const t = token();
    if (!t) return;
    try {
      const r = await fetch('/api/mi-empresa/aviso', { headers: { Authorization: `Bearer ${t}` } });
      if (!r.ok) { setEstado(SIN_AVISO); return; }
      const d = await r.json();
      setEstado({ cargando: false, pendiente: d.aplica === true && d.pendiente === true, datos: d });
    } catch {
      setEstado(SIN_AVISO);
    }
  }, []);

  useEffect(() => { carga(); }, [carga]);

  const aceptado = useCallback(() => setEstado((e) => ({ ...e, pendiente: false })), []);

  return { ...estado, recarga: carga, aceptado };
}

/** Acepta la versión que se leyó. Devuelve `{ ok, status, detalle }`. */
export async function aceptaAviso(version) {
  try {
    const r = await fetch('/api/mi-empresa/aviso/aceptar', {
      method: 'POST',
      headers: { Authorization: `Bearer ${token()}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ version }),
    });
    let detalle = '';
    try {
      const d = await r.json();
      detalle = typeof d?.detail === 'string' ? d.detail : '';
    } catch { /* sin cuerpo */ }
    return { ok: r.ok, status: r.status, detalle };
  } catch {
    return { ok: false, status: 0, detalle: '' };
  }
}
